import t from "react";
import "./index.es73.js";
import "./index.es74.js";
import "./index.es75.js";
import "./index.es76.js";
import "./index.es77.js";
import "./index.es78.js";
import "./index.es79.js";
import l from "./index.es80.js";
import "./index.es81.js";
import "./index.es83.js";
import "./index.es84.js";
import "./index.es85.js";
import "./index.es86.js";
import "./index.es87.js";
import "./index.es88.js";
import "./index.es89.js";
import "./index.es90.js";
import "./index.es91.js";
import "./index.es92.js";
import "./index.es93.js";
import "./index.es94.js";
import "./index.es95.js";
import "./index.es96.js";
const j = ({
  groupsTitle: m,
  group: p,
  groupNames: o,
  blockId: i,
  onGroupChange: e
}) => /* @__PURE__ */ t.createElement(t.Fragment, null, o && o.length > 1 && /* @__PURE__ */ t.createElement(
  l,
  {
    label: m,
    name: `block-${i}-groupTitle`,
    options: o.map((r) => ({ label: r, value: r })),
    value: p,
    onChange: e
  }
));
export {
  j as default
};
//# sourceMappingURL=index.es174.js.map
